<a
  routerLink="/"
  aria-label="Inicio"
  class="bg-logo absolute top-[65%] left-2 aspect-31/34 w-20 -translate-y-1/2">
</a>

@if (user()) {
<user-profile-badge [user]="user()!" />
}

<div class="flex flex-col items-center gap-0.5">
  <button
    data-test="logout"
    (click)="logout()"
    class="preset-body-1 text-primary-300 flex cursor-pointer items-center gap-4 transition-colors">
    <icon-app
      class="w-7"
      name="signout" />
  </button>
  <span class="preset-body-4 text-primary-300 text-center"> Cerrar sesión</span>
</div>

<button
  class="shrink-0"
  aria-label="Notificaciones">
  <img
    class="aspect-square size-8"
    src="https://superlikers-themes.s3.us-east-1.amazonaws.com/toniclub/notifications.svg"
    alt="" />
</button>
